export default __webpack_public_path__ + "static/media/Bolts of Raked Flesh.28605836.jpg";